import { lighten } from 'polished';

import { COLOR } from './constants';

interface ThemeSet {
    REPORTING: Theme;
    FORECASTING: Theme;
    DASHBOARDS: Theme;
    MULTI: Theme;
    GENERIC: Theme;
    GENERICBLUE: Theme;
}

export interface Theme {
    main: string;
    mainBorder?: string;
    mainText: string;
    spinnerColor: 'black' | 'white';
    hover?: { main?: string; mainBorder?: string; mainText?: string };
}

const THEME: ThemeSet = {
    REPORTING: {
        main: COLOR.BRAND.REPORTING,
        mainBorder: COLOR.BRAND.REPORTING,
        mainText: COLOR.PRIMARY.WHITE,
        spinnerColor: 'white',
        hover: {
            main: lighten(0.1, COLOR.BRAND.REPORTING),
            mainBorder: lighten(0.1, COLOR.BRAND.REPORTING),
            mainText: COLOR.PRIMARY.WHITE,
        },
    },
    FORECASTING: {
        main: COLOR.BRAND.FORECASTING,
        mainBorder: COLOR.BRAND.FORECASTING,
        mainText: COLOR.PRIMARY.WHITE,
        spinnerColor: 'white',
        hover: {
            main: lighten(0.1, COLOR.BRAND.FORECASTING),
            mainBorder: lighten(0.1, COLOR.BRAND.FORECASTING),
            mainText: COLOR.PRIMARY.WHITE,
        },
    },
    DASHBOARDS: {
        main: COLOR.BRAND.DASHBOARDS,
        mainBorder: COLOR.BRAND.DASHBOARDS,
        mainText: COLOR.PRIMARY.WHITE,
        spinnerColor: 'white',
        hover: {
            main: lighten(0.1, COLOR.BRAND.DASHBOARDS),
            mainBorder: lighten(0.1, COLOR.BRAND.DASHBOARDS),
            mainText: COLOR.PRIMARY.WHITE,
        },
    },
    MULTI: {
        main: COLOR.BRAND.MULTI,
        mainBorder: COLOR.BRAND.MULTI,
        mainText: COLOR.PRIMARY.WHITE,
        spinnerColor: 'white',
        hover: {
            main: lighten(0.1, COLOR.BRAND.MULTI),
            mainBorder: lighten(0.1, COLOR.BRAND.MULTI),
            mainText: COLOR.PRIMARY.WHITE,
        },
    },
    GENERIC: {
        main: COLOR.PRIMARY.WHITE,
        mainBorder: COLOR.MAIN.DARK_GREY,
        mainText: COLOR.MAIN.DARK_GREY,
        spinnerColor: 'black',
        hover: {
            main: COLOR.MAIN.DARK_GREY,
            mainBorder: COLOR.MAIN.DARK_GREY,
            mainText: COLOR.PRIMARY.WHITE,
        },
    },
    GENERICBLUE: {
        main: COLOR.PRIMARY.WHITE,
        mainBorder: COLOR.MAIN.SECONDARY,
        mainText: COLOR.MAIN.SECONDARY,
        spinnerColor: 'white',
        hover: {
            main: COLOR.MAIN.SECONDARY,
            mainBorder: COLOR.MAIN.SECONDARY,
            mainText: COLOR.PRIMARY.WHITE,
        },
    },
};

export default THEME;
